module.exports = __webpack_public_path__ + "img/pl-1.c498b4b.jpeg";